import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";

import { TemplatesModule } from "../support/templates.module";
import { LandingPage } from "./landing.page";
import { LandingPageRoutingModule } from "./landing-routing.module";

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, LandingPageRoutingModule, TemplatesModule],
  declarations: [LandingPage],
})
export class LandingPageModule {}
